import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Basket } from './basket.service';

export interface Order {
  user_id: number,
  user_name: string,
  bill_name: string,
  order_id: number,
  total_price: number,
  status: string,
  confirme_by: number,
  created: Date,
  order: OrderDetail[],
}
export interface OrderDetail {
  id: number,
  barcode: string,
  product_id: number,
  name: string,
  qty: number,
  unit_type: string,
  price: number,
  image: string,
}

export interface body {
  name: string,
  basket: item[],
}
export interface item {
  id: number,
  name: string,
  price: number,
  qty: number,
}
@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private API_ORDER = "/order"
  constructor(private httpClient: HttpClient) { }

  public GetAll() {
    return this.httpClient.get<Order[]>(this.API_ORDER);
  }

  public GetFilter(date: string) {
    return this.httpClient.get<Order[]>(`/api/order/filter?date=${date}`)
  }

  public GetByID(id: number) {
    return this.httpClient.get<Order>(`${this.API_ORDER}/${id}`)
  }

  public saveOrder(orderID: number, basket: Basket[], bill_name: string, user_id: number) {
    let body = { order_id: orderID, name: bill_name, basket: basket, user_id: user_id };
    return this.httpClient.post(this.API_ORDER, body)
  }

  public deleteOrder(id: number) {
    let path = `${this.API_ORDER}/${id}`
    return this.httpClient.delete(path)
  }
  public confirmOder(id: number) {
    var body: any = { 'order_id': id };
    return this.httpClient.put(`${this.API_ORDER}/confirm`, body)
  }
}
